import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getResultadosEvaluacionThunk } from "../../../store/reducers/dashboard/resultadosEvaluacion/resultadosEvaluacion.thunks";
import TablaResultadosEvaluacion from "./TablaResultadosEvaluacion";
import SearchInput from "../../UI/SearchInput";
import Pagination from "../../UI/Pagination";

const ResultadosEvaluacionContainer = () => {
  const dispatch = useDispatch();
  const { resultados, count, loading, next, previous } = useSelector(
    (state) => state.resultadosEvaluacion
  );
  const { escuela, plantel } = useSelector((state) => state.dashboardFilters);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setCurrentPage(1);
    dispatch(getResultadosEvaluacionThunk({ page: 1, search }));
  }, [dispatch, escuela, plantel, search]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(getResultadosEvaluacionThunk({ page, search }));
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setCurrentPage(1);
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
        <h6 className="mb-0 fw-bold text-lg">Resultados de Evaluación</h6>
        <SearchInput
          value={search}
          onChange={handleSearchChange}
          placeholder="Buscar por email..."
          minChars={3}
          className="mb-0"
        />
      </div>
      <div className="card-body p-24">
        <TablaResultadosEvaluacion resultados={resultados} loading={loading} />
        
        {!loading && (
          <Pagination
            page={currentPage}
            count={count}
            pageSize={10}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default ResultadosEvaluacionContainer;
